import { useAppDispatch, useAppSelector, useMediaQuery } from '../../hooks';
import React, { useCallback, useState } from 'react';
import { SIGN_RESET } from '../../actions/sign';
import Popup from './Popup';

import { ErrorSpan } from '../../styles/Login.styled';
import { Btn } from '../../styles/Button.styled';

import { CircularProgress } from '@mui/material';
import PasswordInput from './PasswordInput';

type SignPopupProps = {
  clickCloseButton?: () => void;
  onSubmit?: (e: React.FormEvent) => void;
  className?: string;
  sign?: SignProps;
};

export function SignPopup(props: SignPopupProps) {
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.user);
  const [activeButton, setActiveButton] = useState(false);
  const mobile = useMediaQuery('(max-width: 767px)');

  const closePopup = useCallback((e) => {
    e.preventDefault();
    if (props.clickCloseButton) {
      props.clickCloseButton();
    }
  });


  const inputChange = useCallback(
    (e) => {
      setActiveButton(e.currentTarget.value.length > 0);
      if (props.sign.state === 'failure') {
        dispatch({ type: SIGN_RESET });
      }
    },
    [props.sign],
  );

  const submitForm = useCallback((e) => {
    e.preventDefault();
    if (props.onSubmit) {
      const data = new FormData(e.currentTarget);
      const key = Object.fromEntries(data.entries());
      props.onSubmit({ ...key, name: user.key });
    }
  });

  return (
    <Popup clickCloseButton={props.clickCloseButton}>
      <h1>Підписати Грядою</h1>
      <p style={{marginBottom:"34px"}}>Введіть пароль до ключа</p>

      <form onSubmit={submitForm}>
        <PasswordInput
          activeButton={activeButton}
          passwordChange={inputChange}
          $marginBottom={mobile ? "10px" : "15px"}
          $heightMobile={"47px"}
        />

        <ErrorSpan $marginTop="-10px" >
          {props.sign.state === 'failure'
            ? `Помилка: ${props.sign.result?.message}`
            : null}
        </ErrorSpan>
        <div  style={{width:"calc(100% - 40px)",display:"flex", gap: "10px", position:"absolute", bottom:"20px"}}>
          <Btn
            type="button"
            $width="100%"
            $color="var(--blue)"
            // $height={isMobile ? '40px' : '47px'}
            $heightMobile="47px"
            $marginTop="20px"
            onClick={closePopup}
            $background='var(--sidebar-hover)'
          >
              Відмінити
          </Btn>

          <Btn
            type="submit"
            disabled={!activeButton || props.sign.state === 'loading'}
            $width="100%"
            $marginTop="20px"
            // $height={mobile ? "40px" : "47px"}
            $heightMobile="47px"
            $background='var(--blue)'
            $disabledColor='var(--disabled-c)'
            $disabledC='var(--white)'
            >
            {props.sign.state === 'loading' ? (
              <CircularProgress
                size={24}
                sx={{
                  color: 'var(--white)',
                }}
              />
            ) : (
              'Підписати'
            )}
          </Btn>
        </div>
      </form>
    </Popup>
  );
}
